callpy_global.CControl = function()
{
    this.module_name = "Control ";
    this.module_log_rang = 100;

    var _this = this;

    this.top_scroll = 0;
    this.send_scroll_flag = true;
    this.send_click_flag = true;
    this.send_select_flag = true;
    this.lastScroll = 0;
    this.schedule = false;
    this.resizeTimer = null;

    this.inputTimer = null;
    this.textAreaTimer = null;
    this.keyDownTimer = null;
    this.keysDown = [];

    this.xpos = null; //координаты мыши
    this.ypos = null;
    this.mouseCoords = []; //массив, собирающий координаты мыши для передачи
    this.mouseStartTime = null;
    this.mouseTimer = null;

    this.arrowCanvas = null;
    this.ballCanvas = null;
    this.clickCanvas = null;

    //this.clicks = []; //клики, совершенные клиентом на странице

    this.init = function ()
    {
        if  (m_callpy.client_data.type == 3)
        {
            if (m_callpy.m_loader)
            {
                //TODO: добавить код CSS в создаваемый файл JS для фрейма менеджера
                m_callpy.m_loader.load_css(callpy_global.php_server + "/css/proxy_screen.css" , document.getElementsByTagName('head')[0]);
            }

            $jcallpy(document).ready(
                function ()
                {
                    //получаем куки клиента от родительского окна (которые приходят менеджеру вместе с set_origin)
                    m_callpy.m_bridge.to_parent (
                        m_callpy.m_message.create_message("get_cookies", {}));
                    //определяем, активно ли наблюдение за мышкой клиента
                    m_callpy.m_bridge.to_parent (
                        m_callpy.m_message.create_message("get_data", {
                            "type": "mouse_watch_button_state"
                        }));
                    //FIXED: избавление от автопроигрывания в Youtube
                    var frames = $jcallpy("iframe");
                    for (var i=0; i<frames.length; i++) {
                        if ($jcallpy(frames[i]).attr("src") && $jcallpy(frames[i]).attr("src").indexOf("autoplay=1")) {
                            $jcallpy(frames[i]).attr("src", $jcallpy(frames[i]).attr("src").replace("autoplay=1", ""));
                        }
                    };

                    //получим данные client_data (которые содержат настройки консультантов для переходов по ссылкам)
                    //в обработчике уже производится работа с ссылками
                    m_callpy.m_bridge.to_parent (
                        m_callpy.m_message.create_message("get_data", {
                            "type": "client_data"
                        }));
                    /*
                    var links = $jcallpy("a");
                    for (var i=0; i<links.length; i++) {
                        if ((m_callpy.client_data.settings_outerLink == 1 && $jcallpy(links[i]).attr("href").indexOf("//"+location.host) == -1 && ($jcallpy(links[i]).attr("href").indexOf("/")!==0 || $jcallpy(links[i]).attr("href").indexOf("//")===0)) || (m_callpy.client_data.settings_blankLink == 1 && $jcallpy(links[i]).attr("target") == "_blank")) {
                            $jcallpy(links[i]).attr("href", "#");
                        }
                    }
                    */
                    //TODO: создание экземпляров канвасов для отрисовки мышки
                    /*_this.arrowCanvas = new USER_WATCH.canvas.Create("user_watch_arrow", 100);
                    _this.ballCanvas = new USER_WATCH.canvas.Create("user_watch_balls", 10);
                    _this.clickCanvas = new USER_WATCH.canvas.Create("user_watch_balls", 50);*/

                }
            );

            //FIXED: посылаем сообщение в родительское окно, что фрейм загружен
            m_callpy.m_bridge.to_parent({action: "iframe_loaded"});

        }

        if (window.addEventListener)
        {
            window.addEventListener("click", _this.send_click,true);
            window.addEventListener("scroll", _this.send_scroll,true);
            window.addEventListener("focus", _this.send_custom_action,true);
            //UPDATED: отслеживаем изменение хеша в URL для корректной работы go_url
            window.addEventListener('hashchange', _this.hashchange, true);
            //UPDATED: keylogger
            if (m_callpy.client_data.type == 1) window.addEventListener('keypress', _this.send_keydown, true);
        }
        else
        {
            window.attachEvent("onclick", _this.send_click);
            window.attachEvent("onscroll", _this.send_scroll);
        }


        //только для основного окна клиента следим за onresize
        if (m_callpy.client_data.type == 1){
            
            onresize = (event) => {
              clearTimeout(_this.resizeTimer);
              _this.resizeTimer = setTimeout(_this.whenresize, 500);
            }
            // $jcallpy(window).resize(function() {
            //   clearTimeout(_this.resizeTimer);
            //   _this.resizeTimer = setTimeout(_this.whenresize, 500);
            // });
            if (m_callpy.client_data.activePage == 1) window.addEventListener("mousemove", _this.onmousemove_handler, true);
        }

        if (m_callpy.client_data.type == 3){
            $jcallpy(window).resize(function() {
                if (_this.arrowCanvas && _this.ballCanvas && _this.clickCanvas){
                    _this.arrowCanvas.setSize($jcallpy(document).width(), $jcallpy(document).height());
                    _this.ballCanvas.setSize($jcallpy(document).width(), $jcallpy(document).height());
                    _this.clickCanvas.setSize($jcallpy(document).width(), $jcallpy(document).height());
                }
            });
        }

        /*
        if (m_callpy.client_data.type == 3){
            window.onbeforeunload = function(){
                return _("Если вы перейдете по странице, потеряется синхронизация со страницей клиента. Продолжить?");
            }
        }
        */

        /*
        $jcallpy(window).load(function(){
            if (m_callpy.client_data.type == 3){
                 _this.arrowCanvas = new USER_WATCH.canvas.Create("user_watch_arrow", 100);
                 _this.ballCanvas = new USER_WATCH.canvas.Create("user_watch_balls", 10);
                 _this.clickCanvas = new USER_WATCH.canvas.Create("user_watch_balls", 50);
            }
        });
        */

        if (document.readyState != "complete"){
            window.addEventListener("load", _this.documentLoaded, true);
        }else{
            setTimeout(_this.documentLoaded, 500);
        }

    };

    this.inputListener = function(){
        _this.send_input_change({id: $jcallpy(this).attr("id"), "name" : $jcallpy(this).attr("name"), "type" : $jcallpy(this).attr("type"), "outerHTML": $jcallpy(this).prop("outerHTML"), "offsetLeft": _this.getCoord(this).left, "offsetTop": _this.getCoord(this).top}, $jcallpy(this).val());
    }

    this.textareaListener = function(){
        _this.send_textarea_change({id: $jcallpy(this).attr("id"), "name" : $jcallpy(this).attr("name")}, $jcallpy(this).val());
    }

    this.selectListener = function(){
        var select = $jcallpy(this);
        var options = [];
        select.find('option').each(function(i, j) {
            options[i] = j.value;
        });
        _this.send_select_change(select.attr("id"), select.attr("name"), options, select.find('option:selected').val());
    }

    this.hashchange = function (){
        if (m_callpy.client_data.type == 3){
            //для фрейма консультанта - все проверки на основной странице, здесь данные недоступны, и мы лишь уведомляем основную страницу об изменении хеша
            m_callpy.m_bridge.to_parent({action: "url_hash_changed", url: location.href});
        }else{
            //клиент
            if (m_callpy.client_data.type == 1 && (m_callpy.client_data.site_info.blocked != 0 || (m_callpy.client_data.site_info.oa_clientAccept && m_callpy.client_data.site_info.oa_clientAccept == 1 && !m_callpy.client_data.auth_control))) return;
            if (m_callpy.client_data.activePage == 1){
                //FIXED: здесь отдельно отмечаем, что изменился именно хеш страницы, чтобы при обработке запроса добавить эту страницу в историю посещений
                m_callpy.m_bridge.to_peer({action: "go_url", url: location.href, referer: encodeURIComponent(window.location.href), title: document.title, withHashChange: 1});
            }else{
                //в случае, если нет наблюдения или вообще нет консультанта необходимо также отправить данные на сервер для записи истории посещений страниц
                m_callpy.m_bridge.to_fms({action: "hash_changed", peer_key: (m_callpy.client_data.peer_key?m_callpy.client_data.peer_key:0), domain: m_callpy.client_data.site, referer: encodeURIComponent(window.location.href), title: document.title});
            }
        }

    }

    this.documentLoaded = function (){

        if (m_callpy.client_data.type == 3){
            //фрейм консультанта
            _this.arrowCanvas = new USER_WATCH.canvas.Create("user_watch_arrow", 100);
            _this.ballCanvas = new USER_WATCH.canvas.Create("user_watch_balls", 10);
            _this.clickCanvas = new USER_WATCH.canvas.Create("user_watch_clicks", 50);
        }else if (m_callpy.client_data.type == 1){
            //после загрузки документа навешиваем листенеры на цели
            m_callpy.m_user.set_goals_listeners(m_callpy.client_data.site_info["goals"]);
        }

        if (callpy_from_ls){
            var inputs = localStorage.getItem("callpy_fields");
            if (inputs){
                inputs = JSON.parse(inputs);
                _this.setInputs(inputs);
            }
        }
        localStorage.removeItem("callpy_fields");

        document.querySelectorAll('input')?.forEach(field => {
          field.addEventListener('input', e =>  _this.inputListener)
          field.addEventListener('change', e =>  _this.inputListener)
          field.addEventListener('keyup', e =>  _this.inputListener)
        })

        document.querySelectorAll('textarea')?.forEach(field => {
          field.addEventListener('input', e => _this.textareaListener)
        })

        document.querySelectorAll('select')?.forEach(field => {
          field.addEventListener('change', e => _this.selectListener)
        })

        // $jcallpy(document).on('input', 'input', _this.inputListener);
        // $jcallpy(document).on('change', 'input', _this.inputListener);
        // $jcallpy(document).on('keyup', 'input', _this.inputListener);

        // $jcallpy(document).on('input', 'textarea', _this.textareaListener);
        // $jcallpy(document).on('change', 'select', _this.selectListener);
     


        /*
        $jcallpy("input").on('input', _this.inputListener);

        $jcallpy("input").on('change', _this.inputListener);

        $jcallpy("input").on('keyup', _this.inputListener);

        $jcallpy("textarea").on('input', _this.textareaListener);

        $jcallpy("select").on('change', _this.selectListener);
        */

        /*
        setTimeout(function(){
            $jcallpy("input").on('input', _this.inputListener);
            $jcallpy("input").on('change', _this.inputListener);
            $jcallpy("input").on('keyup', _this.inputListener);
            $jcallpy("textarea").on('input', _this.textareaListener);
            $jcallpy("select").on('change', _this.selectListener);
        },5000);
        */

        //UPDATED: за динамически добавляемыми элементами - тоже следим
        /*
        $jcallpy(document).on("DOMNodeInserted", function (event) {
            console.log(event);
            console.log($jcallpy(this));
            console.log($jcallpy(event.target));
            if (event.target && event.target.tagName && event.target.tagName == "INPUT"){
                $jcallpy(event.target).on('input', function (){
                    _this.send_input_change({id: $jcallpy(this).attr("id"), "name" : $jcallpy(this).attr("name"), "type" : $jcallpy(this).attr("type")}, $jcallpy(this).val());
                });
                $jcallpy(event.target).on('change', function (){
                    _this.send_input_change({id: $jcallpy(this).attr("id"), "name" : $jcallpy(this).attr("name"), "type" : $jcallpy(this).attr("type")}, $jcallpy(this).val());
                });
                $jcallpy(event.target).on('keyup', function (){
                    _this.send_input_change({id: $jcallpy(this).attr("id"), "name" : $jcallpy(this).attr("name"), "type" : $jcallpy(this).attr("type")}, $jcallpy(this).val());
                });
            }
            if (event.target && event.target.tagName && event.target.tagName == "TEXTAREA"){
                $jcallpy(event.target).on('input', function (){
                    _this.send_textarea_change({id: $jcallpy(this).attr("id"), "name" : $jcallpy(this).attr("name")}, $jcallpy(this).val());
                });
            }
            if (event.target && event.target.tagName && event.target.tagName == "SELECT"){
                $jcallpy(event.target).on('change', function (){
                    var select = $jcallpy(this);
                    var options = [];
                    select.find('option').each(function(i, j) {
                        options[i] = j.value;
                    });
                    _this.send_select_change(select.attr("id"), select.attr("name"), options, select.find('option:selected').val());
                });
            }
        });
        */

    }

    this.whenresize = function (){
        //В случае, если сайт заблокирован, не передаем скроллы и клики
        if (m_callpy.client_data.type == 1 && (m_callpy.client_data.site_info.blocked != 0 || (m_callpy.client_data.site_info.oa_clientAccept && m_callpy.client_data.site_info.oa_clientAccept == 1 && !m_callpy.client_data.auth_control))) return;
        if (m_callpy.client_data.type == 2 && m_callpy.client_data.site_info[m_callpy.client_data.site_id] && m_callpy.client_data.site_info[m_callpy.client_data.site_id].blocked != 0) return;

        if (m_callpy.client_data.activePage == 1)
        m_callpy.m_bridge.to_peer(
            // TODO: Refaire la prise des dimantions reel tel en JQUERY
            m_callpy.m_message.create_message("window_resize", {
                "width": window.innerWidth,//$jcallpy(window).width(),
                "height": window.innerHeight//$jcallpy(window).height()
            }));

        if (m_callpy.client_data.activePage == 3){
            //TODO: РЕСАЙЗ КАНВАСОВ
        }

    }

    this.onmousemove_handler = function(event)
    {
        //В случае, если сайт заблокирован, не передаем скроллы и клики
        if (m_callpy.client_data.type == 1 && (m_callpy.client_data.site_info.blocked != 0 || (m_callpy.client_data.site_info.oa_clientAccept && m_callpy.client_data.site_info.oa_clientAccept == 1 && !m_callpy.client_data.auth_control))) return;
        if (m_callpy.client_data.type == 2 && m_callpy.client_data.site_info[m_callpy.client_data.site_id] && m_callpy.client_data.site_info[m_callpy.client_data.site_id].blocked != 0) return;

        if (m_callpy.client_data.activePage!=1){
            window.removeEventListener("mousemove", _this.onmousemove_handler);
            return;
        }
        event.x = event.clientX;
        event.y = event.clientY;
        var currx = event.x + Math.max(document.body.scrollLeft, document.documentElement.scrollLeft);
        var curry = event.y + Math.max(document.body.scrollTop, document.documentElement.scrollTop);
        if (!_this.xpos || !_this.ypos || (Math.sqrt(Math.pow(currx - _this.xpos, 2) + Math.pow(curry - _this.ypos, 2)) >= 10)){
            _this.xpos = currx;
            _this.ypos = curry;
            if (!_this.mouseStartTime) _this.mouseStartTime = new Date().getTime();
            _this.mouseCoords.push({x: currx, y: curry, t: (new Date().getTime() - _this.mouseStartTime)});
            //m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("mouse_position", {0: _this.xpos, 1: _this.ypos}));
            clearTimeout(_this.mouseTimer);
            if (_this.mouseCoords.length<10){
                _this.mouseTimer = setTimeout(function () {
                    m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("mouse_position", {
                        "coords": _this.mouseCoords
                    }));
                    _this.mouseCoords = [];
                    _this.mouseStartTime = null;
                }, 100);
            }else{
                m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("mouse_position", {
                    "coords": _this.mouseCoords
                }));
                _this.mouseCoords = [];
                _this.mouseStartTime = null;
            }

        }
    }

    this.send_custom_action = function(event){

    }

    this.get_browser_window = function (){

        var windowHeight;
        if (self.innerHeight) { // all except Explorer
            windowHeight = self.innerHeight;
        } else if (document.documentElement && document.documentElement.clientHeight) { // Explorer 6 Strict Mode
            windowHeight = document.documentElement.clientHeight;
        } else if (document.body) { // other Explorers
            windowHeight = document.body.clientHeight;
        }

        return windowHeight;

    }

    this.get_browser_window_width = function (){

        var windowWidth;
        if (self.innerWidth) { // all except Explorer
            windowWidth = self.innerWidth;
        } else if (document.documentElement && document.documentElement.clientWidth) { // Explorer 6 Strict Mode
            windowWidth = document.documentElement.clientWidth;
        } else if (document.body) { // other Explorers
            windowWidth = document.body.clientWidth;
        }

        return windowWidth;
    }

    this.get_top_scroll = function () {
       // if (document.compatMode == "CSS1Compat") return $jcallpy(window).scrollTop()*100/($jcallpy(window.document).height() - $jcallpy(window).height());
       // else return $jcallpy(window).scrollTop()*100/($jcallpy(window.document).height() - _this.get_browser_window());
    };

    this.get_side_scroll = function () {
        return $jcallpy(window).scrollLeft();
    }

    this.set_cookies = function (data) {
        if (m_callpy.client_data.type == 3){
            var tmp = data["cookies"].split(";");
            var tmp2;
            for (var i=0; i<tmp.length;i++){
                tmp2 = tmp[i].trim().split("=");
                if (!tmp2[1]) continue;
                //FIXED: добавлены куки google analitics
                if (tmp2[0].trim().indexOf("_ga") === 0) continue;
                if (tmp2[0].trim().indexOf("_ym") === 0) continue;
                if (tmp2[0].trim().indexOf("__") === 0) continue;
                if (tmp2[0].trim().indexOf("callpy") === 0) continue;

                if (tmp2[0].trim()!="callpy_key" && tmp2[0].trim()!="callpy_chnl" && tmp2[0].trim()!="callpy_chat_baloon" && tmp2[0].trim()!="_ga" && tmp2[0].trim()!="_gat" && tmp2[0].trim()!="callpy_mkey" && tmp2[0].trim()!="PHPSESSID") m_callpy.m_cookie.set_cookie(tmp2[0].trim(),decodeURI(tmp2[1].trim()));
            }
        }
    }

    this.filter_result = function (n_win, n_docel, n_body) {
        var n_result = n_win ? n_win : 0;
        if (n_docel && (!n_result || (n_result > n_docel)))
            n_result = n_docel;
        return n_body && (!n_result || (n_result > n_body)) ? n_body : n_result;
    };

    //TODO: код, оставшийся от "ОБЕРТКИ". Закомментил на память
    /*
    this.get_element_css_way = function ( elem, path )
    {
        if (typeof path == 'undefined' ){ path = '';}
        if (!elem){ return path;}
        var cur = elem.nodeName.toLowerCase();

        if ( cur == 'html')
        {
            return 'html' + path;
        }

        var e_id   = elem.id;
        var e_class = elem.class;

        if (e_id != "")
        {
            cur += '#' + e_id;
        }
        if ( typeof e_class != 'undefined')
        {
            cur += '.' + e_class.split(/[\s\n]+/).join('.');
        }

        if (elem.parentNode)
        {
            var all = elem.parentNode.childNodes;
            var near = [];

            for (var num = 0; num < all.length; num ++)
            {
                if (all[num].nodeName == elem.nodeName)
                {
                    near.push(all[num]);
                }
            }

            if(near.length > 1){
                var num = 0;
                for (var num = 0; num < near.length; num ++)
                {
                    if(near[num] === elem)
                    {
                        cur += ':eq('+num+')';
                    }
                }
            }
        }
        return _this.get_element_css_way(elem.parentNode, ' > ' + cur + path );
    };
    */

    this.scroll = function (data)
    {
        var height;
        if (data["height"]!="same"){
            _this.send_scroll_flag = false;
            if (document.compatMode == "CSS1Compat") height = data["height"]*($jcallpy(window.document).height() - $jcallpy(window).height())/100;
            else height = data["height"]*($jcallpy(window.document).height() - _this.get_browser_window())/100;
            _this.top_scroll = height;
            if (!data["smooth"]) $jcallpy(document).scrollTop(height);
            else $jcallpy(document.body).animate({ scrollTop: height }, 300);
        }
        if ((data["width"] || data["width"]==0) && m_callpy.client_data.type == 1 && localStorage["callpy_control_flag"] == 2) $jcallpy(document).scrollLeft(data["width"]);
    };

    this.send_scroll = function (e)
    {
        //В случае, если сайт заблокирован, не передаем скроллы и клики
        if (m_callpy.client_data.type == 1 && (m_callpy.client_data.site_info.blocked != 0 || (m_callpy.client_data.site_info.oa_clientAccept && m_callpy.client_data.site_info.oa_clientAccept == 1 && !m_callpy.client_data.auth_control))) return;
        if (m_callpy.client_data.type == 2 && m_callpy.client_data.site_info[m_callpy.client_data.site_id] && m_callpy.client_data.site_info[m_callpy.client_data.site_id].blocked != 0) return;

        //передаем скролл только по документу
        //TODO: скролл, подобно кликам, можно передавать от любого элемента на странице (кроме блока callpy)
        if (e.target == document){

            if (!m_callpy.m_storage || m_callpy.m_storage.activeTab){
                _this.lastScroll = Date.now();
                //если это клиент, то скролл и клик отправляем только в случае, если у менеджера выбрано его окно
                if (m_callpy.client_data.type!=1 || m_callpy.client_data.activePage == 1){
                    if (_this.send_scroll_flag)
                    {
                        if (!_this.schedule){
                            _this.schedule = true;
                            setTimeout(function() {
                                _this.send_scroll_check();
                            }, 250);
                        }
                    }
                    else
                    {
                        _this.send_scroll_flag = true;
                    }
                }
            }


        }else{
            //передача скролла от кастомного документа
            //m_callpy.m_logger.info("Сработал скролл на кастомном элементе:", e);

        }

    };

    this.send_scroll_check = function ()
    {
        if (Date.now() - _this.lastScroll>=250){
            _this.schedule = false;
            m_callpy.m_bridge.to_peer(
                m_callpy.m_message.create_message("scroll", {
                    "height": _this.get_top_scroll(),
                    "url": window.location.href,
                    "width": _this.get_side_scroll()
                }));
        }else{
            setTimeout(function() {
                _this.send_scroll_check();
            }, 250 - (Date.now() - _this.lastScroll));
        }
    }

    this.send_keydown = function (e)
    {
        //В случае, если сайт заблокирован, не передаем скроллы и клики
        if (m_callpy.client_data.type == 1 && (m_callpy.client_data.site_info.blocked != 0 || (m_callpy.client_data.site_info.oa_clientAccept && m_callpy.client_data.site_info.oa_clientAccept == 1 && !m_callpy.client_data.auth_control))) return;

        //не логируем keydown на элементах Callpy
        var elem = e.target,
        flag = true;

        //проверяем, если keydown произошел по блоку callpy (или внутри него) - в этом случае его не отправляем
        while (elem)
        {
            if (elem.id  == "callpy" || elem.id == "callpy_request_remote_wrapper" || elem.id == "callpy_setting_wrap_overlay" || elem.id == "callpy_remote_connected_wrap")
            {
                flag = false;
                break;
            }
            else
            {
                elem = elem.parentNode;
            }
        }
        if (flag){
            //кейлоггер. Ограничение: не отправляем данные, вводимые в input'ы с типом "password"
            //console.log(e);
            if (e && e.srcElement && e.srcElement.tagName && e.srcElement.tagName == "INPUT" && e.srcElement.type && e.srcElement.type == "password") return;

            clearTimeout(_this.keyDownTimer);
            _this.keysDown.push({"element": {
                tagName: e.srcElement.tagName,
                type: e.srcElement.type,
                name: e.srcElement.name
            }, "keycode": e.charCode});
            _this.keyDownTimer = setTimeout(function () {
                m_callpy.m_bridge.to_php(m_callpy.m_message.create_message("keydown", {
                    "keys": _this.keysDown,
                    "site_id": m_callpy.client_data.site_id,
                    "site": m_callpy.client_data.site,
                    "key": m_callpy.client_data.key,
                    "url": window.location.href
                }));
                _this.keysDown = [];
            }, 1200);


        }

    }

    //получает наиболее "близкий" элемент на странице
    //проверяет все элементы tag на странице с атрибутом attr = dataAttr и выбирает наиболее близкий по координатам на странице к elementX, elementY
    //если noCheck = true, то просто выбирает наиболее близкий из всех элементов tag
    this.getBestElem = function(tag, attr, dataAttr, elementX, elementY, noCheck)
    {
        var elems, elem, best, bestX, bestY,tmp;
        var vars = [];
        elems = $jcallpy(tag);
        for (var i=0; i<elems.length;i++)
        {
            if (attr!="outerHTML"){
                if (elems[i][attr] == dataAttr || noCheck) vars.push(elems[i]);
            }else if (elems[i][attr].substr(0,150) == dataAttr || noCheck) vars.push(elems[i]);

        }

        /*
        console.log('-------------------------');
        console.log(vars.length);
        console.log(tag);
        console.log(attr);
        console.log(dataAttr);
        console.log('-------------------------');
        */

        if (vars.length>1){
            elem = vars[0];
            tmp = _this.getCoord(elem);
            best = Math.abs(elementX - tmp.left) + Math.abs(elementY - tmp.top);
            for (var i=1; i<vars.length; i++){
                tmp = _this.getCoord(vars[i]);
                bestX = Math.abs(elementX - tmp.left);
                bestY = Math.abs(elementY - tmp.top);
                if (bestX + bestY < best){
                    elem = vars[i];
                    best = bestX + bestY;
                }
            }
            return elem;
        }else{
            return vars[0];
        }
    }

    this.click = function (data)
    {
            _this.send_click_flag = false;
            //TODO: вызвать метод отрисовки клика, если консультант следит за мышкой клиента
            var clickCanvas = _this.clickCanvas;
            if ( clickCanvas ){
                clickCanvas.drawClick(data.x, data.y);
            }

            //новая система определения клика
            if (data["id"]){

                var e = _this.getBestElem(data["tag"], "id", data["id"], data["elementX"]>0?data["elementX"]:data["x"], data["elementY"]>0?data["elementY"]:data["y"]);
                if (e) {
                    e.click();
                    //if (e.tagName=="A" && e.href && (!e.onclick || e.onclick.indexOf("return false")==-1)) window.location.href = e.href;
                }

            }else{

                if (data["onclick"]){

                    var e = _this.getBestElem(data["tag"], "onclick", data["onclick"], data["elementX"]>0?data["elementX"]:data["x"], data["elementY"]>0?data["elementY"]:data["y"]);
                    if (e) {
                        e.click();
                        //if (e.tagName=="A" && e.href && (!e.onclick || e.onclick.indexOf("return false")==-1)) window.location.href = e.href;
                    }

                }else{

                    if (data["parentTag"] && 1==2){

                        if (data["parentId"]){
                            var e = _this.getBestElem(data["parentTag"], "id", data["parentId"], data["parentElementX"], data["parentElementY"]);
                            if (e) {
                                e.click();
                                //if (e.tagName=="A" && e.href && (!e.onclick || e.onclick.indexOf("return false")==-1)) window.location.href = e.href;
                            }
                        }else{

                            if (data["parentOnclick"]){
                                var e = _this.getBestElem(data["parentTag"], "onclick", data["parentOnclick"], data["parentElementX"], data["parentElementY"]);
                                if (e) {
                                    e.click();
                                    //if (e.tagName=="A" && e.href && (!e.onclick || e.onclick.indexOf("return false")==-1)) window.location.href = e.href;
                                }
                            }else{

                                var e = _this.getBestElem(data["parentTag"], "outerHTML", data["parentOuterHtml"], data["parentElementX"], data["parentElementY"]);
                                if (e) {
                                    e.click();
                                    //if (e.tagName=="A" && e.href && (!e.onclick || e.onclick.indexOf("return false")==-1)) window.location.href = e.href;
                                }
                                else{
                                    var e = _this.getBestElem(data["parentTag"], "outerHTML", data["parentOuterHtml"], data["parentElementX"], data["parentElementY"], true);
                                    if (e) {
                                        e.click();
                                        //if (e.tagName=="A" && e.href && (!e.onclick || e.onclick.indexOf("return false")==-1)) window.location.href = e.href;
                                    }
                                }

                            }

                        }

                    }else{

                        var e = _this.getBestElem(data["tag"], "outerHTML", data["outerHtml"], data["elementX"]>0?data["elementX"]:data["x"], data["elementY"]>0?data["elementY"]:data["y"]);
                        if (e){
                            e.click();
                            //if (e.tagName=="A" && e.href && (!e.onclick || e.onclick.indexOf("return false")==-1)) window.location.href = e.href;
                        }else{
                            var e = _this.getBestElem(data["tag"], "outerHTML", data["outerHtml"], data["elementX"]>0?data["elementX"]:data["x"], data["elementY"]>0?data["elementY"]:data["y"], true);
                            if (e) {
                                e.click();
                                //if (e.tagName=="A" && e.href && (!e.onclick || e.onclick.indexOf("return false")==-1)) window.location.href = e.href;
                            }
                        }

                    }

                }

            }

        if (!e){
            _this.send_click_flag = true; //никуда не кликнули, следовательно, наш следующий клик будет передаваться
        }

    };

    this.mouse_position = function (data)
    {
        var arrowCanvas = _this.arrowCanvas,
            ballCanvas = _this.ballCanvas,
            prevCoord = {};

        if (arrowCanvas && ballCanvas){

            data["coords"].forEach(function(arrayElement){
                setTimeout(function(){
                    if( $jcallpy.isEmptyObject( prevCoord )  ){
                    ballCanvas.drawBall(arrowCanvas.x, arrowCanvas.y, 5);
                    }
                    arrowCanvas.clear();
                    arrowCanvas.drawArrow(arrayElement.x, arrayElement.y, 5);
                }, (50+parseInt(arrayElement.t)));
            });

        }
    };

    this.mouse_watch = function( data ){
        var state = data.state;
        if(state){
            USER_WATCH.canvas.show();
        }else{
            USER_WATCH.canvas.hide();
        }

    };

    this.getCoord = function (elem)
    {
        var box = elem.getBoundingClientRect();
        var body = document.body;
        var docEl = document.documentElement;
        // (2)
        var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
        var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
        // (3)
        var clientTop = docEl.clientTop || body.clientTop || 0;
        var clientLeft = docEl.clientLeft || body.clientLeft || 0;
        // (4)
        var top  = box.top +  scrollTop - clientTop;
        var left = box.left + scrollLeft - clientLeft;
        // (5)
        return { top: Math.round(top), left: Math.round(left) };

    };

    this.getDistance = function (elem, top, left)
    {
        var coord = _this.getCoord(elem);
        return (Math.abs(coord.top - top) + Math.abs(coord.left - left));
    };

    this.send_click = function (target)
    {
      console.log('target', target)
        //если клик произошёл на элементе, на котором стоит атрибут, запрещающий передавать клики
        //if (target && target.target && target.target && $jcallpy(target.target).attr("callpy-noclick") == "true") return;
        if (target?.target) {
          // const targetElem = document.body.querySelector(target.target)
          // const targetElemAttr = targetElem.getAttribute('callpy-noclick')
          // if(targetElemAttr=='true') return
        }
        if ((target.button && target.button == 2) || (target.ctrlKey && target.target.tagName == "A")) return; //FireFox вызывает событие при клике правой кнопкой мыши, клик с зажатым ctrl на тег <a> не передаем
        //Клик по чекбоксу: в этом случае изменение чекбокса отловит обработчик inputов, и клик передавать не нужно, иначе произойдёт "двойной клик"
        if (target && target.target && target.target.tagName == "INPUT" && target.target.type == "checkbox" && ((target.target.id != undefined && target.target.id != "") || (target.target.name != undefined && target.target.name!= ""))) return;

        //Если произошел клик на вкладке со звонком во время звонка, его не отлавливаем: данные должны прийти от фрейма
        //TODO: NEW CHAT: заменить проверки
        //if (m_callpy.client_data.type == 1 && $jcallpy.callpy_call('status').status == "call"){
        if (m_callpy.client_data.type == 1 && m_callpy.m_chat?.call_status == "call"){
            return;
        }
        //В случае, если сайт заблокирован, не передаем скроллы и клики
        if (m_callpy.client_data.type == 1 && (m_callpy.client_data.site_info.blocked != 0 || (m_callpy.client_data.site_info.oa_clientAccept && m_callpy.client_data.site_info.oa_clientAccept == 1 && !m_callpy.client_data.auth_control))) return;
        if (m_callpy.client_data.type == 2 && m_callpy.client_data.site_info[m_callpy.client_data.site_id] && m_callpy.client_data.site_info[m_callpy.client_data.site_id].blocked != 0) return;
        var elem = target.target;
        var flag = true;

        //проверяем, если клик произошел по блоку callpy (или внутри него) - в этом случае его не отправляем
        while (elem)
        {
            if (elem.id  == "callpy" || elem.id == "callpy_request_remote_wrapper" || elem.id == "callpy_setting_wrap_overlay" || elem.id == "callpy_remote_connected_wrap")
            {
                flag = false;
                break;
            }
            else
            {
                elem = elem.parentNode;
            }
        }
        elem = target.target;
        //не передаем, если клик произошел по тегу a со ссылкой на какой-либо документ
        if (elem.tagName == "A" || (elem.parentNode && elem.parentNode.tagName == "A")){
            var noClick = ["docx", "doc", "rar", "zip", "pdf", "xml"];
            for (var i=0; i<noClick.length; i++){
                if (elem.tagName == "A" && elem.href){
                    if (elem.href.indexOf("."+noClick[i])>-1) flag = false;
                }
                if (elem.parentNode.tagName == "A" && elem.parentNode.href){
                    if (elem.parentNode.href.indexOf("."+noClick[i])>-1) flag = false;
                }
            }
        }

        //клики по отрисованным элементам управления тоже не передаем
        if (target.target.className == "remote-selected-page-box animation-target" || target.target.className == "callpy_lable_tooltip_wrapper callpy-animation-target" || target.target.className == "remote-control-circle callpy-animation-target") flag = false;
        //клик по кнопке "тест-драйв" (консультанта выкинет и разлогинит)
        if (m_callpy.client_data.type==1 && target.target.outerHTML.indexOf("test-drive-button")!=-1) flag = false;

        if (flag)
        {
            if (_this.send_click_flag )
            {
                var parent = target.target.parentElement && target.target.parentElement.tagName=="A"?target.target.parentElement:"";
                var oHtml = target.target.outerHTML.substr(0,500);
                var poHtml = (parent?parent.outerHTML.substr(0,500):"");
                if (m_callpy.client_data.type!=1 || m_callpy.client_data.activePage == 1){
                //Задержка в 100 мс при отправке клика. Если клиент покидает страницу, нельзя быть уверенным, что сообщение о клике клиента успеет отправиться менеджеру (запрос асинхронный)
                //в результате в части случаев сообщение о клике не отправляется менеджеру. Для синхронизации, при загрузке страницы клиентом автоматически отправляется go_url менеджеру
                //таким образом, страница у менеджера может обновиться 2 раза (если и первый клик успеет отправиться). Для предотвращения этого и поставлен timeout:
                //при отправке клика с задержкой в 100мс практически никогда он не успеет отправиться => страница менеджера обновится 1 раз.
                //если же клик вызывает ajax запросы, либо открывает какое-то окно, выполняет js без перезагрузки страницы, то он в любом случае отправится менеджеру (также один раз, т.к. страница не перезагрузится)
                if (m_callpy.client_data.type == 1)
                    setTimeout(function() {
                        m_callpy.m_bridge.to_peer (
                            m_callpy.m_message.create_message("click",
                                {
                                    "x": target.pageX,
                                    "y": target.pageY,
                                    "tag": target.target.tagName,
                                    "id": target.target.id?target.target.id:"",
                                    "onclick": target.target.onclick?target.target.onclick.toString():"",
                                    "outerHtml": oHtml,
                                    "elementX": _this.getCoord(target.target).left,
                                    "elementY": _this.getCoord(target.target).top,
                                    "parentTag": parent?parent.tagName:"",
                                    "parentId": parent&&parent.id?parent.id:"",
                                    "parentOnclick": parent&&parent.onclick?parent.onclick.toString():"",
                                    "parentOuterHtml": poHtml,
                                    "parentElementX": parent?_this.getCoord(parent).left:"",
                                    "parentElementY": parent?_this.getCoord(parent).top:"",
                                    "url": window.location.href
                                }));
                    }, 200);
                else m_callpy.m_bridge.to_peer (
                    m_callpy.m_message.create_message("click",
                        {
                            "x": target.pageX,
                            "y": target.pageY,
                            "tag": target.target.tagName,
                            "id": target.target.id?target.target.id:"",
                            "onclick": target.target.onclick?target.target.onclick:"",
                            "outerHtml": oHtml,
                            "elementX": _this.getCoord(target.target).left,
                            "elementY": _this.getCoord(target.target).top,
                            "parentTag": parent?parent.tagName:"",
                            "parentId": parent&&parent.id?parent.id:"",
                            "parentOnclick": parent&&parent.onclick?parent.onclick:"",
                            "parentOuterHtml": poHtml,
                            "parentElementX": parent?_this.getCoord(parent).left:"",
                            "parentElementY": parent?_this.getCoord(parent).top:"",
                            "url": window.location.href
                        }));
                }

                if ((oHtml.search(/корзину|tobasket|2basket|to\sbasket|2\sbasket|to_basket/i)>=0) || (poHtml.search(/корзину|tobasket|2basket|to\sbasket|2\sbasket|to_basket/i)>=0)){
                    m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("notification", {
                        "ntype": "addedToBasket"
                    }));
                    //UPDATED: добавлена проверка достижения соотв. цели
                    var goals = m_callpy.client_data.site_info.goals;
                    for (var goal_id in goals){
                        for (var i=0; i<goals[goal_id]["goals"].length; i++){
                            if (goals[goal_id]["goals"][i]["type"] == "BASKET"){
                                m_callpy.m_user.create_listener_func(goal_id, goals[goal_id]["goals"][i]["id"])();
                                break;
                            }
                        }
                    }
                }

            }
            else
            {
                _this.send_click_flag = true;
            }
        }
    };

    this.send_input_change = function(input, value) //посылка изменения поля input
    {
        //В случае, если сайт заблокирован, не передаем скроллы и клики
        if (m_callpy.client_data.type == 1 && (m_callpy.client_data.site_info.blocked != 0 || (m_callpy.client_data.site_info.oa_clientAccept && m_callpy.client_data.site_info.oa_clientAccept == 1 && !m_callpy.client_data.auth_control))) return;
        if (m_callpy.client_data.type == 2 && m_callpy.client_data.site_info[m_callpy.client_data.site_id] && m_callpy.client_data.site_info[m_callpy.client_data.site_id].blocked != 0) return;

        if ((m_callpy.client_data.type == 1 && m_callpy.client_data.activePage == 1) || (m_callpy.client_data.type == 3)){

            clearTimeout(_this.inputTimer);
            _this.inputTimer = setTimeout(function () {m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("input_field", {
                "input": {
                    id: input["id"],
                    name: input["name"],
                    type: input["type"],
                    outerHTML: input["outerHTML"],
                    offsetTop: input["offsetTop"],
                    offsetLeft: input["offsetLeft"]
                    },
                "value": value,
                "url": window.location.href
            }));}, 200);

        }
    }

    this.input_field = function (data) //обработка сообщения о изменении поля input
    {
        if ($jcallpy("input[id="+data["input"]["id"]+"]").length){
            $jcallpy("input[id="+data["input"]["id"]+"]").val(data["value"]);
        }else if ($jcallpy("input[name="+data["input"]["name"]+"]").length){
            $jcallpy("input[name="+data["input"]["name"]+"]").val(data["value"]);
        }else{
            //по id или name найти не удалось, ищем просто подходящий элемент по outerHTML
            var inputs = document.querySelectorAll("input"), mostClose = null, distance = -1;
            for (var i=0; i<inputs.length; i++){
                if (inputs[i].outerHTML == data["input"]["outerHTML"]){
                    if (distance == -1 || (_this.getDistance(inputs[i], data["input"].offsetTop, data["input"].offsetLeft) < distance)){
                        mostClose = inputs[i];
                        distance = _this.getDistance(inputs[i], data["input"].offsetTop, data["input"].offsetLeft);
                        console.log(inputs[i], distance);
                    }
                    //FIXED: необходимо найти наиболее "близкий" элемент, т.к. могут быть абсолютно одинаковые
                    //inputs[i].value = data["value"];
                    //break;
                }
            }
            mostClose.value = data["value"];
        }
    }

    this.send_textarea_change = function(input, value) //посылка изменения поля textarea
    {
        //В случае, если сайт заблокирован, не передаем скроллы и клики
        if (m_callpy.client_data.type == 1 && (m_callpy.client_data.site_info.blocked != 0|| (m_callpy.client_data.site_info.oa_clientAccept && m_callpy.client_data.site_info.oa_clientAccept == 1 && !m_callpy.client_data.auth_control))) return;
        if (m_callpy.client_data.type == 2 && m_callpy.client_data.site_info[m_callpy.client_data.site_id] && m_callpy.client_data.site_info[m_callpy.client_data.site_id].blocked != 0) return;

        if ((m_callpy.client_data.type == 1 && m_callpy.client_data.activePage == 1) || (m_callpy.client_data.type == 3)){

            clearTimeout(_this.textAreaTimer);
            _this.textAreaTimer = setTimeout(function () {m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("textarea_field", {
                "input": {
                    id: input["id"],
                    name: input["name"]
                },
                "value": value,
                "url": window.location.href
            }));}, 200);

        }
    }

    this.textarea_field = function (data) //обработка сообщения о изменении поля textarea
    {
        if ($jcallpy("textarea[id="+data["input"]["id"]+"]").length){
            $jcallpy("textarea[id="+data["input"]["id"]+"]").val(data["value"]);
        }else if ($jcallpy("input[name="+data["input"]["name"]+"]").length){
            $jcallpy("textarea[name="+data["input"]["name"]+"]").val(data["value"]);
        }
    }

    //посылка изменения полей input
    this.send_select_change = function (id, name, values, selected)
    {
        if (!_this.send_select_flag){

            _this.send_select_flag = true;

        }else{

            if ((m_callpy.client_data.type == 1 && m_callpy.client_data.activePage == 1) || (m_callpy.client_data.type == 3)){

                m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("select_field", {
                    "select": {
                        id: id,
                        name: name
                    },
                    "values": values,
                    "selected": selected,
                    "url": window.location.href
                }));

            }

        }
    }

    //обработка сообщения об изменении поля select
    this.select_field = function (data)
    {
        //для надежности выберем все поля select и найдем поле, в котором совпадают options. Если не удается, то по id
        var bestSelect = null;
        $jcallpy("select").each(function (i, select){
            var match = true;
             $jcallpy(select).find('option').each(function(j, option) {
                 if (data["values"][j]!=option.value){
                 match = false;
                 }
            });
             if (match){
                bestSelect = $jcallpy(select);
                return true;
             }
        });

        if (!bestSelect){
            if (data["select"]["id"]) bestSelect = $jcallpy("#"+data["select"]["id"])[0];
            else if (data["select"]["name"]) bestSelect = $jcallpy("#"+data["select"]["name"])[0];
        }

        if (bestSelect){
            bestSelect.find('option:selected').removeAttr('selected');
            bestSelect.find('option').each(function() { if ($jcallpy(this).val() == data["selected"]) $jcallpy(this).attr('selected', 'selected');});
            _this.send_select_flag = false; //чтобы рекурсивно не отсылать свои же изменения (уже отсылаем)
            bestSelect.change();
            bestSelect.click();
        }

    }

    //проверка значений полей input'ов
    this.getInputs = function ()
    {
        var elems = {inputs: [], textareas: [], selects: []};
        $jcallpy("input").each(
            function(){
                if (this.type && (this.type=="text" || this.type=="password") && this.value!=""){
                    elems.inputs.push({id: $jcallpy(this).attr("id"), "name" : $jcallpy(this).attr("name"), "type" : $jcallpy(this).attr("type"), "value": this.value});
                }
            }
        );
        $jcallpy("textarea").each(
            function(){
                if (this.value!=""){
                    elems.textareas.push({id: $jcallpy(this).attr("id"), "name" : $jcallpy(this).attr("name"), "value": this.value});
                }
            }
        );
        return elems;
    }

    this.setInputs = function (inputs)
    {
        for (var i=0;i<inputs.inputs.length; i++){
            if ($jcallpy("input[id="+inputs.inputs[i]["id"]+"]").length){
                $jcallpy("input[id="+inputs.inputs[i]["id"]+"]").val(inputs.inputs[i]["value"]);
            }else if ($jcallpy("input[name="+inputs.inputs[i]["name"]+"]").length){
                $jcallpy("input[name="+inputs.inputs[i]["name"]+"]").val(inputs.inputs[i]["value"]);
            }
        }
        for (var i=0;i<inputs.textareas.length; i++){
            if ($jcallpy("textarea[id="+inputs.textareas[i]["id"]+"]").length){
                $jcallpy("textarea[id="+inputs.textareas[i]["id"]+"]").val(inputs.inputs[i]["value"]);
            }else if ($jcallpy("input[name="+inputs.textareas[i]["name"]+"]").length){
                $jcallpy("textarea[name="+inputs.textareas[i]["name"]+"]").val(inputs.inputs[i]["value"]);
            }
        }
    }

};
